var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.493a2.5 2.5 0 0 0-2.5 2.5v5h5v-5a2.5 2.5 0 0 0-2.5-2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.167 16.993v5H19.5a2.5 2.5 0 0 0 2.5-2.5v-7.6c0-.433-.168-.85-.47-1.16l-7.08-7.656a3.333 3.333 0 0 0-4.897 0L2.484 10.73c-.31.312-.484.735-.484 1.175v7.588a2.5 2.5 0 0 0 2.5 2.5h3.333v-5c.016-2.272 1.85-4.128 4.066-4.181 2.289-.055 4.25 1.832 4.268 4.181Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.493a2.5 2.5 0 0 0-2.5 2.5v5h5v-5a2.5 2.5 0 0 0-2.5-2.5Z"
  })));
};
export default SvgHome;